import { render, staticRenderFns } from "./userViewModel.vue?vue&type=template&id=3755e270&scoped=true"
import script from "./userViewModel.vue?vue&type=script&lang=js"
export * from "./userViewModel.vue?vue&type=script&lang=js"
import style0 from "./userViewModel.vue?vue&type=style&index=0&id=3755e270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755e270",
  null
  
)

export default component.exports